import React from "react";
import "./Home.css";
import userImage from "../../assets/logImage.svg";
import { motion, spring } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faInstagram,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import NavBar from "../nav/NavBar";
import Quote from "../quote/Quote";
import { faComputerMouse } from "@fortawesome/free-solid-svg-icons";

const buttonVariants = {
  tap: {
    scale: 0.9,
    rotate: [0, -5, 5, -5, 5, 0],
    transition: {
      duration: 0.5,
    },
  },
};
const textVariant = {
  initial: {
    x: -500,
    opacity: 0,
  },
  animate: {
    x: 0,
    opacity: 0.5,
    transition: {
      duration: 1,
      staggerChildren: 0.1,
    },
  },
  scrollButton: {
    opacity: 0,
    y: [10],
    transition: {
      yoyo: Infinity,
      ease: "easeInOut",
      duration: 2,
      stiffness: 10,
      repeat: Infinity,
    },
  },
  scrollText: {
    opacity: 1,
    scale: [1, 1.1, 1],
    transition: {
      yoyo: "Infinity",
      ease: "easeInOut",
      duration: 2,
      stiffness: 10,
    },
  },
};
function Home() {
  return (
    <div className="homeMain">
      <NavBar />
      <div className="home__container">
        <div className="socials">
          <motion.div
            className="social-media"
            variants={buttonVariants}
            whileHover="tap"
          >
            <a href="https://www.instagram.com/mikey_mbugua/" target="_blank">
              <FontAwesomeIcon icon={faInstagram} color="#9ab5e7" size="2xl" />
            </a>
          </motion.div>
          <motion.div
            className="social-media"
            variants={buttonVariants}
            whileHover="tap"
          >
            <a href="https://twitter.com/MichaelKamiri2" target="_blank">
              <FontAwesomeIcon icon={faTwitter} color="#9ab5e7" size="2xl" />
            </a>
          </motion.div>
          <motion.div
            className="social-media"
            variants={buttonVariants}
            whileHover="tap"
          >
            <a href="https://www.github.com/mike-mbugua" target="_blank">
              <FontAwesomeIcon icon={faGithub} color="#9ab5e7" size="2xl" />
            </a>
          </motion.div>
          <motion.div
            className="social-media"
            variants={buttonVariants}
            whileHover="tap"
          >
            <a
              href="https://www.linkedin.com/in/michael-kamiri-mbugua/"
              target="_blank"
            >
              <FontAwesomeIcon icon={faLinkedin} color="#9ab5e7" size="2xl" />
            </a>
          </motion.div>
        </div>
        <div className="left__Home__container">
          <motion.div
            className="home__description"
            initial={{ opacity: 1, scale: 1.2 }}
            transition={{ type: "spring", stiffness: 100, damping: 100 }}
            whileInView={{ opacity: 1.5, scale: 1 }}
          >
            <h2>
              Hi i am Mike a{" "}
              <span className="fancyColor">Full stack web developer</span> and{" "}
              <span className="fancyColor">Junior Mobile Dev</span> <br />
              💻 📱
            </h2>
          </motion.div>
          <motion.div
            className="minor__description"
            variants={textVariant}
            animate="scrollText"
          >
            I've spent the last 3 years building and scaling software for some
            pretty cool companies. I also teach people to code.Let's connect!
          </motion.div>
          <motion.div
            className="button"
            whileTap="tap"
            variants={buttonVariants}
          >
            Contact me
          </motion.div>
        </div>
        <motion.div
          className="right__Home__container"
          initial={{ opacity: 1, scale: 1.2 }}
          transition={{ duration: 3 }}
          whileInView={{ opacity: 1.5, scale: 1 }}
        >
          <img src={userImage} alt="" />
        </motion.div>
        <motion.div
          variants={textVariant}
          initial={{ opacity: 0.5 }}
          animate="scrollButton"
        >
          {" "}
          <FontAwesomeIcon icon={faComputerMouse} size="2xl" />
        </motion.div>
      </div>
      <Quote />
    </div>
  );
}

export default Home;
